"use client";

import { useEffect, useState } from "react";

/**
 * Hero background that cross-fades through a set of images on a timer.
 * Used by HomeHero for the `gallery` background mode. All images are stacked
 * absolutely to fill the positioned parent; the active one is opaque, the rest
 * transparent, with a 3s opacity transition between them. Decorative — the
 * headline carries the copy.
 */
export function HeroSlideshow({
  images,
  intervalMs = 3000,
}: {
  images: string[];
  intervalMs?: number;
}) {
  const [active, setActive] = useState(0);

  useEffect(() => {
    if (images.length < 2) return;
    const id = setInterval(() => {
      setActive((i) => (i + 1) % images.length);
    }, intervalMs);
    return () => clearInterval(id);
  }, [images.length, intervalMs]);

  return (
    <>
      {images.map((src, i) => (
        // eslint-disable-next-line @next/next/no-img-element
        <img
          key={src}
          src={src}
          alt=""
          aria-hidden
          className={`absolute inset-0 h-full w-full object-cover transition-opacity duration-[3000ms] ease-out ${
            i === active ? "opacity-100" : "opacity-0"
          }`}
        />
      ))}
    </>
  );
}
